<template>
  <v-container fluid fill-height>
    <v-card max-width="1000" class="mx-auto">
      <v-list-item>
        <v-row>
          <v-col
            class="d-flex justify-center align-center"
            cols="12"
            sm="12"
            md="6"
          >
            <div>
              <v-img
                :src="require('@/assets/img/candidati/ubiali.jpg')"
                class="rounded-circle my-6"
                max-height="400"
                max-width="400"
                :width="imageWidth"
                :height="imageWidth"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="6">
            <v-list-item-content>
              <v-list-item-title class="display-1 font-weight-bold mb-1"
                >Gianluigi Ubiali</v-list-item-title
              >
              <v-list-item-title class="subtitle-1 font-weight-bold mb-6"
                >Candidato sindaco</v-list-item-title
              >
              <div>
                <p>
                  Sono Gianluigi Ubiali, ho 58 anni, sono sposato con Enrica e
                  padre di Serena, 19enne studentessa universitaria.
                </p>
                <p>Vivo a Mozzo da quando mi sono sposato, 29 anni fa.</p>
                <p>
                  Sono un impiegato tecnico informatico nel settore
                  dell'ingegneria strutturale e ambientale.
                </p>
                <p>
                  Ho deciso di candidarmi per dare continuità al progetto
                  amministrativo in cui mi sono impegnato in questi 10 anni,
                  forte dell'esperienza maturata e delle competenze acquisite.
                </p>
                <p>
                  Sento di dover dare ancora qualcosa al mio Paese, a chi ha
                  espresso stima nella mia persona, ai colleghi consiglieri con
                  cui ho lavorato, a molti amici e alla gente che incontro e con
                  cui ho creato solide esperienze di relazione e confronto.
                </p>
                <p>
                  La mia convinzione è che, prima dei programmi, Mozzo abbia
                  ancora bisogno di persone: bisogno di donne e uomini liberi di
                  fare politica per passione, di spendersi per un Paese
                  accogliente, civile e unito nelle sue differenze, attenti ai
                  bisogni di tutti e capaci di mantenere vivo il rapporto di
                  fiducia tra cittadinanza e istituzioni.
                </p>
                <p>
                  Con onestà, competenza, trasparenza, concretezza e
                  solidarietà.
                </p>
              </div>
            </v-list-item-content>
          </v-col>
        </v-row>
      </v-list-item>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "250px";
        case "sm":
          return "400px";
        case "md":
          return "400px";
        case "lg":
          return "400px";
        case "xl":
          return "400px";
      }
    },
  },
};
</script>